import {
  sliceEvents,
  createPlugin,
  PluginDef
} from '@fullcalendar/core';

import moment from 'moment-timezone';

type CustomContent = {
  html: string;
};


/* from https://github.com/fullcalendar/fullcalendar/blob/main/packages/core/src/View.ts

export interface ViewProps {
  dateProfile: DateProfile
  businessHours: EventStore
  eventStore: EventStore
  eventUiBases: EventUiHash
  dateSelection: DateSpan | null
  eventSelection: string
  eventDrag: EventInteractionState | null
  eventResize: EventInteractionState | null
  isHeightAuto: boolean
  forPrint: boolean
}
*/


const ButtonsViewConfig = {
  classNames: ['buttons-view'],

  content: function(props: any): CustomContent {
    let segs = sliceEvents(props, true).sort((a, b) =>
      a!.instance!.range!.start!.getTime() - b!.instance!.range!.start!.getTime()
    );

    let groups: Record<string, any[]> = {}; // group by day
    segs.forEach(seg => {
      let date = seg!.instance!.range!.start;

      //let m = toMoment(date, calendar)
      let key = date.toISOString().slice(0, 10); // YYYY-MM-DD

      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(seg);
    });

    let sortedDays = Object.keys(groups).sort();

    //    let html = '<table>';
    let html = "";

    sortedDays.forEach(dayString => {
      if (dayString >= new Date().toISOString().slice(0, 10)) {
        const [, month, day] = dayString.split('-');
        html += `<fieldset class="button-group-fieldset"><legend class="has-text-weight-semibold">${Number(day)}.${Number(month)}.</legend>`;
        html += `<div class="buttons">`;

        groups[dayString].forEach(seg => {
          const dateString = seg!.instance!.range!.start.toISOString();
          const hour = Number(dateString.slice(11, 13));
          const minute = dateString.slice(14, 16);
          const timeString = `${hour}:${minute}`;

          const type = seg!.def!.extendedProps!.type;
          const eid = seg!.def!.extendedProps!.eid;
          if (type == 'free')
            html += `<button class="button is-success is-view-button " data-eid="${eid}" data-start="${seg!.instance!.range!.start}"> ${timeString}</button>`;
          else
            html += `<button class="button is-static "> ${timeString} </button>`;
        });

        html += '</div></fieldset>';
      }
    });

    html += '</table>';
    return { html }
  },

  didMount: function(props: any) {
  },

  willUnmount: function(props: any) {
  }
}

const plugin: PluginDef = createPlugin({
  views: {
    buttons: ButtonsViewConfig
  }
} as any) as PluginDef;

export default plugin;

